import { CenteredPage, PrimaryButton } from '@cmg/common';
import { xcSelectors } from '@cmg/e2e-selectors';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import routeFactory from '../../common/util/routeFactory';

export const SMessage = styled.div`
  font-size: ${({ theme }) => theme.text.size.mediumLarge};
  margin: 15px 0 40px 0;
`;
export const SHeading = styled.div`
  font-size: ${({ theme }) => theme.text.size.large};
  margin: 25px 0 12px;
`;

/**
 * The user will arrive at this route whenever they logout of Docs SPA (automatically or purposefully).
 */
const LoggedOutRoute: React.FC = () => (
  <CenteredPage testId={xcSelectors.loggedOutScreenSelector.testId}>
    <SHeading>You have been successfully logged out</SHeading>
    <SMessage>For your security, we recommend you close your browser.</SMessage>
    <PrimaryButton
      variant="high-contrast"
      testId={xcSelectors.backToLoginButtonSelector.testId}
      asComponent={Link}
      to={routeFactory.oidcLogin.getUrlPath()}
      size="large"
      fullWidth
    >
      Return to Login Page
    </PrimaryButton>
  </CenteredPage>
);

// eslint-disable-next-line
// TODO - we could connect this and redirect if user is logged in so no one accidentally lands on this route
export default LoggedOutRoute;
